// import TopForm from "../components/TopForm";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useState } from "react";

// IMPORT SVG
import { ReactComponent as ChevronLeft } from "../assets/feathericons/chevron-left.svg";
import { ReactComponent as Check } from "../assets/feathericons/check.svg";
import { ReactComponent as Trash } from "../assets/feathericons/trash.svg";

const FormAdd = () => {
  const history = useHistory();
  const [data, setData] = useState(null);
  const [name, setName] = useState(null);

  // add new form with name and "open" the next step for add questions (go to /form/:id/edit)
  const handleSubmit = (event) => {
    event.preventDefault();
    if (!name) {
      // name required
      console.log("nom du formulaire obligatoire");
    } else {
      const fetchData = async () => {
        try {
          const response = await axios.post(
            "https://tellmemore-mahe.herokuapp.com/form/add",
            { name: name }
          );
          setData(response.data);
          history.push({
            pathname: `/form/${response.data._id}/edit`,
            state: response.data,
          });
        } catch (error) {
          console.log(error.message);
        }
      };
      fetchData();
    }
  };

  return (
    <>
      <div className="form form-edit margin50">
        <div className="top-screen">
          <div className="my-forms">
            <ChevronLeft />
            <p
              onClick={() => {
                history.push("/");
              }}
            >
              Mes formulaires
            </p>
          </div>
          <div className="row">
            {/* on submit, save the state name in db */}
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                onChange={(event) => setName(event.target.value)}
              />
              <button type="submit" className="check">
                <Check style={{ height: 18 }} />
              </button>
            </form>
          </div>
          {/* all in grey color and can't click before add new form */}
          <div className="row">
            <form>
              <a className="trashgrey" href="#">
                <Trash style={{ height: 15 }} />
              </a>
            </form>
            <a className="btn-answer-grey" href="#">
              Répondre
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormAdd;
